module.exports = __webpack_public_path__ + "static/media/advantage.92ed8063.svg";